export default "__VITE_ASSET__C60iePxw__"